import { render, staticRenderFns } from "./VendorSubList.vue?vue&type=template&id=06c06e47&scoped=true&"
import script from "./VendorSubList.vue?vue&type=script&lang=js&"
export * from "./VendorSubList.vue?vue&type=script&lang=js&"
import style0 from "./VendorSubList.vue?vue&type=style&index=0&id=06c06e47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c06e47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c06e47')) {
      api.createRecord('06c06e47', component.options)
    } else {
      api.reload('06c06e47', component.options)
    }
    module.hot.accept("./VendorSubList.vue?vue&type=template&id=06c06e47&scoped=true&", function () {
      api.rerender('06c06e47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/vendors/VendorSubList.vue"
export default component.exports